import { useGetAnnotatorProjectsQuery } from '../api/annotatorProjectsApiSlice';

export const useAnnotatorProjectsDataGridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetAnnotatorProjectsQuery> => {
  return useGetAnnotatorProjectsQuery();
};
